module.exports = __webpack_public_path__ + "static/assets/40d59a6d36dd479f7934cc35c3f6f795.png";